import React from 'react';

import './_year-selector.scss';

const YearSelect = (props)  =>
   (	 
		<>
		<label>Year</label>
		<select className="form-control" id="yearSelector" onChange={props.change}>
		   <option value="All">All-Time</option>
							{props.data.map((year, index) => {
					 return <option key={'key'+index} value={year}>{year}</option>
					})}
			 </select>
			 </>  );
          
          
export default YearSelect;